import React from "react";

function ErrorWrapper({ children }) {
  return <p className="text-xs text-red-500">{children}</p>;
}

export default ErrorWrapper;
